/* Klaviyo consent gate - 24 Sep 2026.
   The cookie banner and the Klaviyo popup used to appear on the same first load and together
   covered the whole phone screen. This hides the Klaviyo form until the visitor has answered
   the cookie banner, then reveals it 3s later. Returning visitors (consent already stored)
   see no banner, so the form shows after the same 3s. Fallback: reveal after 60s regardless.
   Delete this file and its line in layout/theme.liquid to revert. */
(function () {
  var SEL = '.klaviyo-form, .needsclick[class*="kl-private-reset-css"], div[class*="kl-private-reset-css"]';
  var GATE = 'kl-consent-gate-style';
  var REVEAL_AFTER_CONSENT_MS = 3000;
  var HARD_FALLBACK_MS = 60000;

  function addGate() {
    if (document.getElementById(GATE)) return;
    var s = document.createElement('style');
    s.id = GATE;
    s.textContent = SEL + '{display:none !important;visibility:hidden !important;}';
    (document.head || document.documentElement).appendChild(s);
  }
  function removeGate() {
    var s = document.getElementById(GATE);
    if (s) s.parentNode.removeChild(s);
  }
  function decided() {
    try {
      var c = window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.currentVisitorConsent();
      if (!c) return false;
      // any non-empty value means the visitor made a choice (accept or decline)
      return !!(c.analytics || c.marketing || c.preferences);
    } catch (e) { return false; }
  }
  function bannerGone() {
    var b = document.querySelector('#shopify-pc__banner');
    return !b || b.offsetHeight === 0;
  }

  addGate();
  var start = Date.now();
  var iv = setInterval(function () {
    var timeout = Date.now() - start > HARD_FALLBACK_MS;
    if ((decided() && bannerGone()) || timeout) {
      clearInterval(iv);
      setTimeout(removeGate, timeout ? 0 : REVEAL_AFTER_CONSENT_MS);
    }
  }, 400);
})();
